import InfiniteScroll from "react-infinite-scroll-component";
import { Loader } from "../../Common/Loader";
import ShowToast from "../../Common/Toast";
import { STATUS_BEGIN } from "../../../../utils/constants/others";
import {
  PurchaseOrderCard,
  PurchaseOrderContactModal,
  PurchaseOrderErrorState,
  PurchaseOrderListMobileHeader,
  PurchaseOrderSearchPrompt,
  PurchaseOrderStatusFilters,
} from "./PurchaseOrderListElements";
import PurchaseOrderListEmptyState from "./PurchaseOrderListEmptyState";
import { CardList, Content, Page, ScrollLoader, StateContainer } from "./styles";

const PURCHASE_ORDER_LIST_SCROLL_CONTAINER_ID = "purchase-order-list-scroll-container";

export default function PurchaseOrderListMobile({
  activePage,
  selectedStatuses,
  toggleStatus,
  searchVisible,
  searchQuery,
  setSearchQuery,
  toastMessage,
  selectedContact,
  setSelectedContact,
  activePageConfig,
  emptyStateDestination,
  pageCounts,
  purchaseOrderTableRowData,
  hasNextPurchaseOrderDetailsPage,
  isSearching,
  showSearchPrompt,
  minimumSearchLength,
  normalizedSearchQuery,
  isInitialLoading,
  hasError,
  handlePageChange,
  loadNextPage,
  handleCall,
  getPurchaseOrderActions,
  toggleSearch,
  fetchPurchaseOrders,
  getPurchaseOrderDetailsStatus,
}) {
  return (
    <Page id={PURCHASE_ORDER_LIST_SCROLL_CONTAINER_ID}>
      <PurchaseOrderListMobileHeader
        activePage={activePage}
        searchQuery={searchQuery}
        searchVisible={searchVisible}
        onPageChange={handlePageChange}
        onSearchChange={setSearchQuery}
        onToggleSearch={toggleSearch}
      />

      <Content>
        {!searchVisible && (
          <PurchaseOrderStatusFilters
            statuses={activePageConfig.statuses}
            selectedStatuses={selectedStatuses}
            onToggle={toggleStatus}
          />
        )}

        {showSearchPrompt && (
          <PurchaseOrderSearchPrompt
            minimumCharacters={minimumSearchLength}
            numericOnly={/^\d+$/.test(normalizedSearchQuery)}
          />
        )}

        {!showSearchPrompt && (isInitialLoading || getPurchaseOrderDetailsStatus === STATUS_BEGIN) && (
          <StateContainer>
            <Loader isScrollLoader />
          </StateContainer>
        )}

        {!showSearchPrompt && !isInitialLoading && getPurchaseOrderDetailsStatus !== STATUS_BEGIN && hasError && (
          <PurchaseOrderErrorState onRetry={() => fetchPurchaseOrders(1, true)} />
        )}

        {!showSearchPrompt && !isInitialLoading && getPurchaseOrderDetailsStatus !== STATUS_BEGIN && !hasError && purchaseOrderTableRowData.length === 0 && (
          <PurchaseOrderListEmptyState
            pageConfig={activePageConfig}
            nextPage={emptyStateDestination}
            onOpenPage={handlePageChange}
          />
        )}

        {!showSearchPrompt && purchaseOrderTableRowData.length > 0 && (
          <InfiniteScroll
            dataLength={purchaseOrderTableRowData.length}
            hasMore={hasNextPurchaseOrderDetailsPage}
            next={loadNextPage}
            scrollableTarget={PURCHASE_ORDER_LIST_SCROLL_CONTAINER_ID}
            loader={
              <ScrollLoader>
                <Loader isScrollLoader />
              </ScrollLoader>
            }
          >
            <CardList>
              {purchaseOrderTableRowData.map((row) => (
                <PurchaseOrderCard
                  key={`${row.id}-${row.poStatus}`}
                  item={row._raw}
                  actions={getPurchaseOrderActions(row._raw)}
                />
              ))}
            </CardList>
          </InfiniteScroll>
        )}
      </Content>

      <PurchaseOrderContactModal
        contact={selectedContact}
        onClose={() => setSelectedContact(null)}
        onCall={handleCall}
      />

      {toastMessage && <ShowToast errorMsg={toastMessage} />}
    </Page>
  );
}
